export default [
  {
    name: 'vuepress',
    stars: 13101,
    issues: 131,
    contributors: 210,
  },
  {
    name: 'vetur',
    stars: 3489,
    issues: 141,
    contributors: 60,
  },
  {
    name: 'vue-cli',
    stars: 21462,
    issues: 305,
    contributors: 263,
  },
  {
    name: 'vuejs.org',
    stars: 3779,
    issues: 80,
    contributors: 546,
  },
  {
    name: 'awesome-vue',
    stars: 46548,
    issues: 71,
    contributors: 1497,
  },
  {
    name: 'vue',
    stars: 142452,
    issues: 218,
    contributors: 276,
  },
  {
    name: 'vue-devtools',
    stars: 14112,
    issues: 139,
    contributors: 82,
  },
  {
    name: 'ui',
    stars: 979,
    issues: 5,
    contributors: 6,
  },
  {
    name: 'vue-router',
    stars: 14041,
    issues: 126,
    contributors: 189,
  },
  {
    name: 'rfcs',
    stars: 1296,
    issues: 9,
    contributors: 6,
  },
  {
    name: 'vue-class-component',
    stars: 3605,
    issues: 8,
    contributors: 28,
  },
  {
    name: 'vue-test-utils',
    stars: 2468,
    issues: 69,
    contributors: 163,
  },
  {
    name: 'vuefire',
    stars: 2392,
    issues: 14,
    contributors: 25,
  },
  {
    name: 'vuex',
    stars: 20813,
    issues: 87,
    contributors: 246,
  },
  {
    name: 'nuxt',
    stars: 20934,
    issues: 207,
    contributors: 153,
  },
  {
    name: 'vue-apollo',
    stars: 3795,
    issues: 126,
    contributors: 71,
  },
];
